import { ReactNode, RefObject } from "react";

import QueryModalTitle from "views/components/QueryModal/QueryModalTitle";
import SubmitQueryButton from "views/components/QueryModal/SubmitQueryButton";
import QueryModalOperators from "views/components/QueryModal/QueryModalOperators";
import QueryModal from "views/components/QueryModal";

import styles from "./style.module.scss";

interface Operators<T> {
  selected: T;
  options: (T | { value: T; label: string })[];
  onSelect: (operator: T) => void;
}

interface BaseQueryModalProps<T> {
  title: string;
  icon: ReactNode;
  children: ReactNode;
  isSubmitDisabled: boolean;
  keepOpenOnLoading?: boolean;
  modalRef: RefObject<HTMLDivElement>;
  operators?: Operators<T>;
  onSubmit: () => void;
}

export default function BaseQueryModal<T>({
  icon,
  title,
  modalRef,
  children,
  isSubmitDisabled,
  keepOpenOnLoading = false,
  onSubmit,
  operators,
}: BaseQueryModalProps<T>) {
  return (
    <QueryModal modalRef={modalRef} keepOpenOnLoading={keepOpenOnLoading}>
      <QueryModalTitle icon={icon}>{title}</QueryModalTitle>
      <div className={styles.filterContent}>
        {operators && (
          <QueryModalOperators
            operators={operators.options}
            selectedOperator={operators.selected}
            onSelect={operators.onSelect}
          />
        )}
        {children}
        <SubmitQueryButton isDisabled={isSubmitDisabled} onSubmit={onSubmit} />
      </div>
    </QueryModal>
  );
}
